import React from "react";
import { Route, Switch } from "react-router-dom";
import AuthenticatedRoute from "./components/AuthenticatedRoute";
import UnauthenticatedRoute from "./components/UnauthenticateRoute";

import Login from "./containers/Login/login";
import NotFound from "./containers/NotFound/NotFound";
import main from "./containers/main/main";
import DeviceInfo from "./containers/DeviceInfo/deviceinfo";
import TempCodeRqst from "./containers/TempCodeRqst/tempcoderqst";
import About from "./containers/About/about";
import CodeScan from "./containers/CodeScan/codescan";
import OpenCloseCodes from "./containers/OpenCloseCodes/openCloseCodes";

export default ({ childProps }) =>
  <Switch>
    <UnauthenticatedRoute path="/login" exact component={Login} props={childProps} />
    <AuthenticatedRoute path="/" exact component={main} props={childProps} />
    <AuthenticatedRoute path="/DeviceInfo" exact component={DeviceInfo} props={childProps} />
    <AuthenticatedRoute path="/TempCodeRqst" exact component={TempCodeRqst} props={childProps} />    
    <AuthenticatedRoute path="/About" exact component={About} props={childProps} />
    <AuthenticatedRoute path="/CodeScan" exact component={CodeScan} props={childProps} />
    <AuthenticatedRoute path="/OpenCloseCodes" exact component={OpenCloseCodes} props={childProps} />   
    {/* <AuthenticatedRoute path="/AdminTools" exact component={AdminTools} props={childProps} /> */}
    { /* Finally, catch all unmatched routes */ }
    <Route component={NotFound} />
  </Switch>;


// WEBPACK FOOTER //
// ./src/Routes.js